import { createSelector } from 'reselect';
import { formatTemplatePickerTemplate } from '../utils';

const getTemplates = (state: { templatePicker: any }) => state.templatePicker;
const getTemplatesById = (state: { templatePicker: { templatesById: any } }) =>
  state.templatePicker.templatesById;
export const getTemplateDetailsById = (state: { templatePicker: { templateDetailsById: any } }) =>
  state.templatePicker.templateDetailsById;

export const getSmsSenders = (state: { templatePicker: { senders: { smsSenders: any } } }) =>
  state.templatePicker?.senders?.smsSenders || [];
export const getAuthedEmails = (state: { templatePicker: { senders: { authedEmails: any } } }) =>
  state.templatePicker?.senders?.authedEmails || [];

export const getFetchingTemplates = (state: { templatePicker: { isFetchingTemplates: any } }) =>
  state.templatePicker.isFetchingTemplates;

export const getTemplatesListQueryIds = (state: any, { queryString }: { queryString: string }) =>
  state?.templatePicker?.templatesListQueries?.[queryString]?.templateIds || [];

export const getTemplatesListQueryTotals = (state: any, { queryString }: { queryString: string }) =>
  state.templatePicker.templatesListQueries?.[queryString]?.total ?? null;

export const selectTemplatesByQuery = createSelector(
  [getTemplatesById, getTemplateDetailsById, getTemplatesListQueryIds],
  (templatesById, templateDetailsById, templateIds) => {
    // we're taking the templates,
    const queriedTemplates = templateIds
      .reduce((templates: any, id: string | number) => {
        if (!templatesById[id]) {
          return templates;
        }
        return [...templates, templatesById[id]];
      }, [])
      .map((template: { id: string | number }) => {
        /**
          and then ADDING additional template details gotten from a different endpoint 
          and stored elsewhere in redux.(yay for graphql when this can call be simplified)
         
          NOTE: the ID field coming in off template details can conflict, so we exclude it
         */

        const { id, ...templateDetails } = templateDetailsById?.[template.id] || {};

        return {
          ...template,
          ...templateDetails,
        };
      });

    // and then formatting it with some additional data stuff
    return queriedTemplates.map(formatTemplatePickerTemplate);
  },
);

export const getIsLoading = (state: any) => getTemplates(state)?.loading;

export const getMessageMediumFromCampaignId = (
  state: any,
  { campaignId }: { campaignId: number },
) => state.templatePicker.campaigns?.[campaignId]?.messageMedium;

export const getDataFeeds = (state: { templatePicker: { dataFeeds: any } }) =>
  state.templatePicker.dataFeeds;

export const getMemberData = (state: any, { memberId }: { memberId: number }) =>
  state.templatePicker.membersById[memberId] || {};

export const getCampaignTemplateIdFromCampaignId = (
  state: any,
  { campaignId }: { campaignId: number },
) => state.templatePicker.campaigns?.[campaignId]?.templateId;

export const getCampaignMobileAppIds = (state: any, { campaignId }: { campaignId: number }) =>
  state.templatePicker.campaigns?.[campaignId]?.mobileAppIds;

export const selectSendersExist = createSelector([getSmsSenders], (smsSenders) => {
  return smsSenders.length > 0;
});

export const selectAuthedEmailsExist = createSelector([getAuthedEmails], (authedEmails) => {
  return authedEmails.length > 0;
});
